import React from 'react';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';

const Tabs = ({ children }) => (
  <div className="tabs">
    {React.Children.toArray(children).map(child => (
      React.cloneElement(child, {
        key: uuid(),
      })
    ))}
  </div>
);

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Tabs;
